import Contact from "components/Contact";
import Head from "next/head";
import HummingFooter from "pages/components/HummingFooter";
import HummingNav from "pages/components/HummingNav";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import FAQLayout from "./components/faq";
import styles from "./styles.module.scss";

const FAQ: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>FAQs | Humming Homes </title>
        <meta
          name="description"
          content="Read the most frequently asked questions and answers about Humming Homes' policies and services. "
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/faq" />
      </Head>
      <FAQLayout />
      <Contact />
    </div>
  );
};

FAQ.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default FAQ;
